/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';
import { useResponsiveImage } from '@/utils/useResponsiveImage';
import { UploadFileEntityResponse } from '@/graphql/generated/graphql';
import Container from '../Container';
type ImageInput = UploadFileEntityResponse | { url: string; alternativeText: string } | undefined;

export type HighlightType = {
  title?: string;
  description?: string;
  thumbnail?: ImageInput;
};

export default function PageHighlight({ title, description, thumbnail }: HighlightType) {
  const { src } = useResponsiveImage(thumbnail);

  return (
    <AnimatedFadeInComponent>
      <Container>
        <div className="col-span-12 flex flex-col items-start lg:col-start-11 lg:col-end-3">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-[415px_1fr]">
            <div className="flex aspect-video items-center justify-center overflow-hidden rounded-2xl bg-primary-200/10  md:aspect-square">
              {src && (
                <img
                  className="h-full max-h-[415px] w-full rounded-2xl object-cover object-center"
                  src={src}
                  alt={title?.toString() || ''}
                />
              )}
            </div>
            <div>
              <span className="md:sh-36-48 font-larken text-sh-36-48 ">{title?.toString()}</span>
              <p className="mt-2 text-sh-xxs md:text-sh-sm">{description?.toString()}</p>
            </div>
          </div>
        </div>
      </Container>
    </AnimatedFadeInComponent>
  );
}
